import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';

@Component({
  selector: 'app-pick-ups-per-business',
  templateUrl: './pick-ups-per-business.component.html',
  styleUrls: ['./pick-ups-per-business.component.scss']
})
export class PickUpsPerBusinessComponent implements OnInit {

  @Input() business;
  @Output() onPickUPListClick = new EventEmitter<string>();
  constructor() { }

  ngOnInit(): void {
  }

}
